export const normalizeStringField = (value: string): string =>
	encodeURIComponent(value.replace(/'/g, "''"));
